import React from 'react';
import moment from 'moment';
import { convertAddressObjToString } from './../../../../helpers';
import sessionsDateFormat from '../../../../helpers/formatSessionDate';
import { Divider } from 'antd';
import * as T from '../../../common/Typography';
import { readableCourseName } from '../../../../constants/index';
import {
  Text,
  EmailWrapper,
  EmailText,
  BoldSpan
} from '../SessionDetails.Style';

const EmailTemplate = ({ sessionDetails, activeEmailTemplate }) => {
  const fullAddress = convertAddressObjToString(sessionDetails.address);
  const modulesAsString =
    (sessionDetails.modules && sessionDetails.modules.join(', ')) || 'N/A';
  let startTimes = sessionDetails?.dates
    ?.map(e => e?.startTime)
    ?.filter(e => e !== null);
  let endTimes = sessionDetails?.dates
    ?.map(e => e?.endTime)
    ?.filter(e => e !== null);
  let datesArr = sessionDetails?.dates?.filter(e => e.sessionDate !== null);
  return (
    <div>
      <EmailWrapper>
        <div>
          <T.P color="gray" inline>
            <Text> Session Date(s):</Text>{' '}
            {datesArr?.length &&
              datesArr?.map((date, i) => {
                if (i === datesArr?.length - 1) {
                  return moment(date.sessionDate).format('DD/MM/YYYY');
                } else {
                  return (
                    <>
                      {moment(date.sessionDate).format('DD/MM')}
                      ,&nbsp;
                    </>
                  );
                }
              })}{' '}
          </T.P>
        </div>
        <div>
          <Text>Message:</Text>
        </div>
        <EmailText>Dear course participants,</EmailText>
        <EmailText>
          This is a friendly reminder of your upcoming Gwent Connect 5 training
          session:
        </EmailText>
        <ul style={{ paddingLeft: '2rem', marginTop: '1rem' }}>
          <li>
            <EmailText>
              <BoldSpan>Session Date(s):</BoldSpan>{' '}
              {sessionDetails?.dates
                ? sessionsDateFormat(sessionDetails.dates)
                : 'N/A'}
            </EmailText>
          </li>
          <li>
            <EmailText>
              <BoldSpan>Module(s):</BoldSpan> {modulesAsString}
            </EmailText>
          </li>
          <li>
            <EmailText>
              <BoldSpan>Course:</BoldSpan>{' '}
              {readableCourseName(sessionDetails.course)}
            </EmailText>
          </li>
          {sessionDetails.remote ? (
            <>
              <li>Location: Online</li>
              <li>
                Meeting link:{' '}
                {sessionDetails.meetingLink ? (
                  <a href={sessionDetails.meetingLink}>
                    {sessionDetails.meetingLink}
                  </a>
                ) : (
                  'TBC'
                )}
              </li>
              <li>
                Meeting platform: {sessionDetails.meetingPlatform || 'TBC'}
              </li>
            </>
          ) : (
            <li> Location: {fullAddress || 'TBC'}</li>
          )}
          <li>
            <T.P color="gray">
              <BoldSpan>Time:</BoldSpan>

              {!startTimes?.length
                ? 'N/A'
                : startTimes.length === 1 ||
                  (startTimes.every(val => val === startTimes[0]) &&
                    endTimes.every(val => val === endTimes[0]))
                ? `${startTimes[0]} - ${endTimes[0]}`
                : 'Times vary'}
            </T.P>
          </li>
          <li>
            <EmailText>
              <BoldSpan>Trainer(s):</BoldSpan>{' '}
              {activeEmailTemplate.trainers || 'N/A'}
            </EmailText>
          </li>
        </ul>

        <EmailText>
          To track your own progress and to ensure that our trainings are
          effective we rely on course participants to fill out surveys after
          each session. All the data is anonymised. After answering surveys you
          can immediately see your own progress and access certificates via the
          app. You will receive a link to the post-session evaluation from your
          trainers.
        </EmailText>
        {activeEmailTemplate.preSurveyLink && (
          <>
            <br />
            <EmailText>
              <b>
                Before starting the training session please follow this link and
                fill out the{' '}
                <a
                  href={activeEmailTemplate.preSurveyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  pre-course evaluation
                </a>
                .
              </b>
            </EmailText>
          </>
        )}

        <br />

        {activeEmailTemplate.extraInformation && (
          <EmailText as="pre">{activeEmailTemplate.extraInformation}</EmailText>
        )}

        <br />
        <EmailText>Sincerely,</EmailText>
        <EmailText>Your Gwent Connect 5 team</EmailText>

        <Divider />
        <Text>
          <BoldSpan>Sent To:</BoldSpan>
        </Text>
        {activeEmailTemplate.recipients &&
          activeEmailTemplate.recipients.map(email => (
            <EmailText key={email}>{email}</EmailText>
          ))}
      </EmailWrapper>
    </div>
  );
};

export default EmailTemplate;
